module.exports = __webpack_public_path__ + "static/media/adrashya-sms.1b618945.png";